// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TreeListHead_wrapper__2l_D6","arrows":"TreeListHead_arrows__kTs89","rotated":"TreeListHead_rotated__kuPWx","bold":"TreeListHead_bold__60YmH"};